// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingExportResponse

export type BillingExportApiResponse = {
	success: boolean;
	message: string;
};

export type BillingExport = {
	success: boolean;
	message: string;
};

export function hydrateBillingExport(data: BillingExportApiResponse): BillingExport {
	return { ...data };
}